var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "20px",
    viewBox: "0 0 30 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "32x32/Cloud_Up_Fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.355,16.57269 L17.355,22.699005 C17.355,23.43459 16.76226,24.03 16.02,24.03 C15.28308,24.03 14.685,23.433255 14.685,22.699005 L14.685,16.57269 L12.958845,18.298845 C12.438195,18.82083 11.591805,18.82083 11.071155,18.298845 C10.54917,17.778195 10.54917,16.931805 11.071155,16.411155 L15.076155,12.406155 C15.596805,11.88417 16.443195,11.88417 16.963845,12.406155 L20.968845,16.411155 C21.49083,16.931805 21.49083,17.778195 20.968845,18.298845 C20.448195,18.82083 19.601805,18.82083 19.081155,18.298845 L17.355,16.57269 Z M30.705,19.3575 C30.705,22.674975 28.014975,25.365 24.6975,25.365 L8.6775,25.365 C4.62177,25.365 1.335,22.07823 1.335,18.0225 C1.335,14.07891 4.444215,10.86156 8.345085,10.68801 C10.069905,8.206245 12.91212,6.675 16.02,6.675 C20.215905,6.675 23.82441,9.458475 24.98052,13.356675 C28.167165,13.503525 30.705,16.13481 30.705,19.3575 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02-Collab",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.1-\\u2014-Collab-\\xB7-Default",
    transform: "translate(-378.000000, -486.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload-BTN",
    transform: "translate(361.000000, 464.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "32x32/Cloud_Up_Fill",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpFill);
export default __webpack_public_path__ + "static/media/Cloud_Up_Fill.36c4bbd9be6015fc5049fbf966f62b6f.svg";
export { ForwardRef as ReactComponent };